/**
 * A file name shortened from the middle, so its extension stays visible (F20-h FR-C2, AC-19; F20-h
 * WI-1.2 plan Decision 13): `quarterly-price-list-for-…-2026.xlsx`. Computed in code, not by CSS, so a
 * test can assert the text. Counted in whole code points, so a surrogate pair (an emoji) is never split.
 *
 * The extension is the text after the last `.` when it is 1–8 characters and the dot is not the first
 * character; it is kept whole, with its dot. The rest is split around one `…`, the larger half first.
 */

const ELLIPSIS = '…';
const MAX_EXTENSION = 8;

export function shortenFileName(name: string, max = 40): string {
    const points = Array.from(name);
    if (points.length <= max) {
        return name;
    }
    const dot = points.lastIndexOf('.');
    const extensionLength = dot > 0 ? points.length - dot - 1 : 0;
    const keepsExtension = extensionLength >= 1 && extensionLength <= MAX_EXTENSION;
    const tail = keepsExtension ? points.slice(dot) : [];
    const base = keepsExtension ? points.slice(0, dot) : points;
    const room = Math.max(max - tail.length - ELLIPSIS.length, 2);
    const front = Math.ceil(room / 2);
    const back = room - front;
    return [...base.slice(0, front), ELLIPSIS, ...base.slice(base.length - back), ...tail].join('');
}
